import type { FC } from "react";
import Post001, { frontmatter as fm001 } from "./001-the-humaniti-arc.mdx";
import Post002, { frontmatter as fm002 } from "./002-why-consensus-matters.mdx";
import Post003, { frontmatter as fm003 } from "./003-meet-the-first-humans.mdx";

export interface NotesPostFrontmatter {
  number: string;
  slug: string;
  title: string;
  excerpt: string;
  byline: string;
  date: string;
  readingMinutes: number;
}

export interface NotesEntry {
  frontmatter: NotesPostFrontmatter;
  Component: FC;
}

export const NOTES: NotesEntry[] = [
  { frontmatter: fm001 as unknown as NotesPostFrontmatter, Component: Post001 },
  { frontmatter: fm002 as unknown as NotesPostFrontmatter, Component: Post002 },
  { frontmatter: fm003 as unknown as NotesPostFrontmatter, Component: Post003 },
].sort((a, b) => b.frontmatter.date.localeCompare(a.frontmatter.date));

export const findPost = (slug: string): NotesEntry | undefined =>
  NOTES.find((p) => p.frontmatter.slug === slug);
